module.exports = __webpack_public_path__ + "static/media/CloseMenu_AERO.b02d7b3d.svg";